import jsPDF from 'jspdf';
import { IGuild } from '../models';
import { format } from "date-fns";

export const CreatePayoutReceipt = (guild: IGuild, exportResult: string) : Blob => {    
    const d = JSON.parse(exportResult) as any[];
    const supplierData : PayoutReceiptSupplierData = d[0];
    const totalData : PayoutReceiptTotalData = d[1];

    const pdf = new jsPDF();
    pdf.setProperties({
        title: `Kvittering til regnskab - ${guild.name}`
    });

    // Base styles
    pdf.setFont('times', 'normal');
    pdf.setFontSize(20);
    pdf.setLineWidth(0.1);

    // Headline
    pdf.text(guild.name, AlignCenter_CalculateXOffset(pdf, guild.name), 15);

    // Timestamp
    const timestamp = `Udskrevet d. ${new Date().toLocaleDateString()} kl. ${new Date().toLocaleTimeString()}`;
    pdf.setFontSize(11);
    pdf.text(timestamp, AlignCenter_CalculateXOffset(pdf, timestamp), 22);
    pdf.setFontSize(BodyFontSize);

    const vendorData = {
        vendorName: "PBS",
        vendorAddress: "Laustrupbjerg 10",
        vendorAddress2: "Postboks 500",
        vendorZipCity: "2750 Ballerup"
    };

    const receiptData = {
        CVR: totalData.CVRnr,
        TransferType: "80",
        DispositionDate: format(new Date(totalData.Valørdato), "ddMMyy"),
        BankSender: `${totalData.BankRegnr} ${totalData.Banknavn}`,
        DataSupplier: supplierData.Datalev,
        DataSupplierCVR: supplierData.DatalevCVRnr,
        PaymentSenderBankAccountNo: supplierData.BankKontonr,
        TransferCount: totalData.AntalPoster + "",
        TotalAmountInDKK: totalData.SamletBeløb.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        ReceiverIdentification: totalData.ModtagerID?.trim() || "Møllelauget",
        PostingIdentifier: guild.name,
        ValidationNumbers: "000000000"
    };

    pdf.text(`${vendorData?.vendorName}`, 13, 45);
    pdf.text(`${vendorData?.vendorAddress}`, 13, 45 + LineHeight);
    pdf.text(`${vendorData?.vendorAddress2}`, 13, 45 + LineHeight * 2);
    pdf.text(`${vendorData?.vendorZipCity}`, 13, 45 + LineHeight * 3);

    pdf.setFont('times', 'bold');
    pdf.setFontSize(14);
    pdf.text('Kvittering for udbetaling', 13, 84);
    pdf.setFont('times', 'normal');
    pdf.setFontSize(BodyFontSize);
    pdf.text('Kontroloplysninger:', 13, 93);
    pdf.text('PBS overførsel:', 13, 93 + LineHeight);

    const rows: [string, string][] = [
        ["Møllelaugets CVR nr.", receiptData.CVR],
        ["Overførselstype", receiptData.TransferType],
        ["Disp. dato", receiptData.DispositionDate],
        ["Betalings afsenders bank", receiptData.BankSender],
        ["Dataleverandør", receiptData.DataSupplier],
        ["Dataleverandør CVR nr.", receiptData.DataSupplierCVR],
        ["Betalingsafsenders kontonr", receiptData.PaymentSenderBankAccountNo],
        ["Antal overførsler", receiptData.TransferCount],
        ["Totalbeløb i DKK", receiptData.TotalAmountInDKK],
        ["Modtageridentifikation", receiptData.ReceiverIdentification],
        ["Posteringsidentifikation", receiptData.PostingIdentifier],
        ["Kontrol for dataleverandør", receiptData.ValidationNumbers]
    ];
    rows.forEach(([label, value], i) => AddTableRowTwoColumn(pdf, 110 + LineHeight * i, label, value));

    // Sender info
    pdf.text('Med venlig hilsen', 13, 196);
    [guild.name, totalData.Attention, totalData.Adresse, totalData.PostnrBy, `Tlf. ${totalData.Telefon}`]
        .forEach((line, i) => pdf.text(line, 13, 220 + LineHeight * i));

    // const pdfDataUri = pdf.output('datauristring');
    // const newTab = window.open();
    // newTab?.document.write(`<iframe width='100%' height='100%' src='${pdfDataUri}'></iframe>`);

    //return pdf.output('datauristring');
    return new Blob([pdf.output('blob')], { type: 'application/pdf' });
}

// Body text size in pt and line spacing in mm (A4 = 210 x 297 mm)
const BodyFontSize = 12;
const LineHeight = 6;

const AddTableRowTwoColumn = (pdf: jsPDF, y: number, label: string, value: string) => {
    pdf.text(label, 13, y);
    pdf.text(value, 80, y);
};

const AlignCenter_CalculateXOffset = (pdf: jsPDF, text: string) : number => {
    return (pdf.internal.pageSize.getWidth() - pdf.getTextWidth(text))/2;
};

export interface PayoutReceiptSupplierData {
    Datalev:      string;
    DatalevCVRnr: string;
    BankRegnr:    number;
    BankKontonr:  string;
    CVRnr:        string;
    Valørdato:    Date;
}

export interface PayoutReceiptTotalData {
    AntalPoster:  number;
    SamletBeløb:  number;
    Valørdato:    Date;
    BankRegnr:    number;
    BankKontonr:  string;
    DatalevCVRnr: string;
    CVRnr:        string;
    Banknavn:     string;
    ModtagerID:   string;
    Attention:    string;
    Adresse:      string;
    PostnrBy:     string;
    Telefon:      string;
}
